import { render, staticRenderFns } from "./DocumentReferenceFileSelector.vue?vue&type=template&id=0370dc88&scoped=true&"
import script from "./DocumentReferenceFileSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentReferenceFileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentReferenceFileSelector.vue?vue&type=style&index=0&id=0370dc88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370dc88",
  null
  
)

export default component.exports